import { render, staticRenderFns } from "./RadioAnimalNumber.vue?vue&type=template&id=b3570c4a&"
import script from "./RadioAnimalNumber.vue?vue&type=script&lang=js&"
export * from "./RadioAnimalNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports